<template lang="pug">
  div
    drop.drop-target(@drop="handleDrop('first', null, droppable(parent, -1), ...arguments)" @dragover="dragOver('first', null, ...arguments)" @dragleave="dragLeave('first', null, ...arguments)" :class="{ 'drag-over': isDragOver('first', null), 'droppable': droppable(parent, -1) }")
      .dropping-between
    template(v-for="menu, iMenu in menus")
      template(v-if="menu.children.length")
        .name
          .action
            v-btn.my-0(icon @click="$emit('edit', menu)"): v-icon edit
          drag(:transfer-data="menu" @dragstart="$emit('dragging', menu); dragI = iMenu" @dragend="$emit('dragging', null); dragI = null")
            span(:class="{ 'grey--text': menu.menu.state !== 'visible'}") {{menu.menu.name}}
            template(slot="image"): div {{menu.menu.name}}
          .action
            v-btn.my-0.mr-0(@click="$set(closedMenus, menu.menu.id, !closedMenus[menu.menu.id])" icon): v-icon {{closedMenus[menu.menu.id] ? 'arrow_drop_down' : 'arrow_drop_up'}}
          drop.drop-target-in(v-if="closedMenus[menu.menu.id]" @drop="handleDrop('in', menu, droppable(menu), ...arguments)" @dragover="dragOver('in', menu, ...arguments)" @dragleave="dragLeave('in', menu, ...arguments)" :class="{ 'drag-over': isDragOver('in', menu), 'droppable': droppable(menu) }")
            .dropping-in
        menu-tree.level(v-if="!closedMenus[menu.menu.id]" :parent="menu" :menus="menu.children" @move="$emit('move', $event)" :edit="edit" @edit="$emit('edit', $event)" :dragging="dragging" @dragging="$emit('dragging', $event)")
      template(v-else)
        .name
          .action
            v-btn.my-0(icon @click="$emit('edit', menu)"): v-icon edit
          drag(:transfer-data="menu" @dragstart="$emit('dragging', menu); dragI = iMenu" @dragend="$emit('dragging', null); dragI = null")
            span(:class="{ 'grey--text': menu.menu.state !== 'visible'}") {{menu.menu.name}}
            template(slot="image"): div {{menu.menu.name}}
          drop.drop-target-in(@drop="handleDrop('in', menu, droppable(menu), ...arguments)" @dragover="dragOver('in', menu, ...arguments)" @dragleave="dragLeave('in', menu, ...arguments)" :class="{ 'drag-over': isDragOver('in', menu), 'droppable': droppable(menu) }")
            .dropping-in
      drop.drop-target(@drop="handleDrop('after', menu, droppable(parent, iMenu), ...arguments)" @dragover="dragOver('after', menu, ...arguments)" @dragleave="dragLeave('after', menu, ...arguments)" :class="{ 'drag-over': isDragOver('after', menu), 'droppable': droppable(parent, iMenu) }")
        .dropping-between

</template>

<style lang="stylus" scoped>
  .name
    display flex
    min-height 2em
    align-items center
    align-content stretch
  .action
    min-width 3em
  .level
    padding-left 3em

  .drop-target
    height 0px
    &:last-child
      height 12px

  .drop-target-in
    flex-grow 1
    height 1em
    min-width 4em

  .droppable
    .dropping-in, .dropping-between
      opacity 0.3
    &.drag-over
      .dropping-in, .dropping-between
        opacity 1

  .dropping-in
    opacity 0
    position relative
    &:after
      content ""
      display block
      position absolute
      top 4px
      left 18px
      width 6px
      height 4px
      background-color black
    &:before
      content ""
      display block
      position absolute
      top 0
      left 12px
      border 6px solid transparent
      border-right-color black
      border-left-width 0

  .dropping-between
    top -6px
    opacity 0
    height 12px
    position relative
    &:after
      content ""
      display block
      position absolute
      top 4px
      left -12px
      width 6px
      height 4px
      background-color black
    &:before
      content ""
      display block
      position absolute
      top 0
      left -6px
      border 6px solid transparent
      border-left-color black
      border-right-width 0

</style>


<script>
import gql from 'graphql-tag'

export default {
  props: ['edit', 'dragging', 'parent', 'menus'],
  name: 'menu-tree',
  data() {
    return {
      closedMenus: {},
      draggingType: null,
      draggingMenu: null,
      dragI: null
    }
  },
  methods: {
    handleDrop(type, menu, droppable, data, event) {
      this.draggingMenu = null
      this.draggingType = null
      if (droppable) {
        this.$emit('move', { type, parent: this.parent, menu, data, event })
      }
    },
    dragOver(type, menu, data, event) {
      this.draggingMenu = menu
      this.draggingType = type
    },
    dragLeave(type, data) {
      this.draggingMenu = null
      this.draggingType = null
    },
    isDragOver(type, data) {
      return this.draggingType === type && this.draggingMenu === data
    },
    droppable(parent, iMenu) {
      if (!this.dragging) {
        return false
      }
      if (iMenu !== null && this.dragI !== null && (this.dragI === iMenu || this.dragI === iMenu + 1)) {
        return false
      }
      const dragId = this.dragging.menu.id
      const parentId = parent.menu.id
      const ancestry = parent.menu.ancestry || ''
      return parentId !== dragId && !ancestry.split('/').some(a => a === dragId)
    }
  }
}
</script>
